
import { Union, Record } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { ClientApiResponse$1_$reflection, FormState_$reflection, RequestedValue$1_$reflection, InspectionTemplateId_$reflection } from "../../../Shared/Shared.js";
import { DTO_InspectionTemplateDetailDto_$reflection } from "../../../Shared/InspectionTemplate.js";
import { Label_$reflection } from "../../../Shared/Category.js";
import { union_type, string_type, class_type, record_type, list_type } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";

export class State extends Record {
    constructor(TemplateId, Template, Categories, FormState) {
        super();
        this.TemplateId = TemplateId;
        this.Template = Template;
        this.Categories = Categories;
        this.FormState = FormState;
    }
}

export function State_$reflection() {
    return record_type("Settings.InspectionTemplate.Detail.Types.State", [], State, () => [["TemplateId", InspectionTemplateId_$reflection()], ["Template", RequestedValue$1_$reflection(DTO_InspectionTemplateDetailDto_$reflection())], ["Categories", RequestedValue$1_$reflection(list_type(Label_$reflection()))], ["FormState", FormState_$reflection()]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["TemplateFetched", "CategoriesFetched", "FetchError", "DeleteTemplate", "TemplateDeleted", "DeleteError"];
    }
}

export function Msg_$reflection() {
    return union_type("Settings.InspectionTemplate.Detail.Types.Msg", [], Msg, () => [[["Item", DTO_InspectionTemplateDetailDto_$reflection()]], [["Item", list_type(Label_$reflection())]], [["Item", class_type("System.Exception")]], [], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", class_type("System.Exception")]]]);
}

